/* unplugin-vue-components disabled */import script from "./battle-map-16.vue?vue&type=script&lang=jsx"
export * from "./battle-map-16.vue?vue&type=script&lang=jsx"

import "./battle-map-16.vue?vue&type=style&index=0&id=5e7bf482&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7bf482"]])

export default __exports__